// FTEDN — useAuth hook
import { useAuthStore } from '../stores/auth.store';

export function useAuth() {
  const { user, isAuthenticated, isLoading, login, loginWithGoogle, signup, logout } = useAuthStore();

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    loginWithGoogle,
    signup,
    logout,
    userId: user?.id || null,
    displayName: user?.displayName || 'Team',
  };
}
